import { Map, Range as ImmutableRange, List } from "immutable";

// assumes a non descending range for now
export const Range = (start, end) => {
  if (start === undefined) throw new Error("Start value is required for Ranges");
  return new Map({
    start,
    end: end ?? start,
  });
};

export const parseRange = (range) => {
  const start = range.get("start");
  const immutableRange = ImmutableRange(start, range.get("end"));
  return immutableRange.size ? immutableRange.toJS() : [start];
};

export const inRange = (index, range) => {
  const start = range.get("start");
  const end = range.get("end");
  return index >= start && index <= end;
};

// assumes the index is within the range
export const getLocalIndex = (index, range) => {
  const start = range.get("start");
  return index - start;
};

const RangeManager = () => {
  /** @type {Map<Range, string>} */
  let storedRanges = new Map({});

  const self = {};

  // todo: check for overlap
  const add = (start, end, type) => {
    const newRange = Range(start, end);
    if (!storedRanges.has(newRange)) storedRanges = storedRanges.set(newRange, type);
  };

  const findHighestRangeEnd = () =>
    (
      storedRanges
        .keySeq()
        .sortBy((range) => range.get("end"))
        .last() ?? new Map({})
    ).get("end");

  const append = (type, size = 1) => {
    const rangeEnd = self.findHighestRangeEnd();
    const startPoint = rangeEnd !== undefined ? rangeEnd + 1 : 0;

    self.add(startPoint, startPoint + size - 1, type);

    return self;
  };

  const findRange = (index) => storedRanges.findKey((_, range) => inRange(index, range));

  const findLocalIndex = (index) => {
    const range = self.findRange(index);
    return getLocalIndex(index, range);
  };

  // for testing
  const getRanges = () => storedRanges;

  const hasRange = (range) => storedRanges.has(range);

  /**
   * 
   * @param {*} cb 
   * @returns 
   */
  const findRanges = (cb) => {
    const items = List(storedRanges.filter(cb).keySeq());
    return items;
  }

  Object.assign(self, {
    add,
    append,
    inRange,
    findRange,
    hasRange,
    getRanges,
    findLocalIndex,
    findHighestRangeEnd,
    findRanges,
  });

  return self;
};

export default RangeManager;
